import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const pasttimeValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const inputDate = control.get('appointmentDate');
    const inputTime = control.get('appointmentTime');

    if (inputTime?.errors && inputTime.errors['timeRequired']) {
        inputTime?.setErrors(null);
    }

    if (!inputDate?.value) {
        return { dateRequired: true };
    }

    if (!inputTime?.value) {
        return null;
    }

    const combinedDateTime = new Date(inputDate.value);
    combinedDateTime.setHours(inputTime?.value.getHours());
    combinedDateTime.setMinutes(inputTime?.value.getMinutes());
    combinedDateTime.setSeconds(inputTime?.value.getSeconds());
    combinedDateTime.setMilliseconds(inputTime?.value.getMilliseconds());

    const todayDateTime = new Date();

    if (combinedDateTime.toDateString() === todayDateTime.toDateString() && combinedDateTime.getTime() >= todayDateTime.getTime()) {
        return { 'pastTimeRequired': { valid: true } }; 
    }

    return null;
};

export const futuretimeValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const inputDate = control.get('appointmentDate');
    const inputTime = control.get('appointmentTime');

    if (inputTime?.errors && inputTime.errors['timeRequired']) {
        inputTime?.setErrors(null);
    }

    if (!inputDate?.value) {
        return { dateRequired: true };
    }

    if (!inputTime?.value) {
        return null;
    }

    const combinedDateTime = new Date(inputDate.value);
    combinedDateTime.setHours(inputTime?.value.getHours());
    combinedDateTime.setMinutes(inputTime?.value.getMinutes());
    combinedDateTime.setSeconds(inputTime?.value.getSeconds());
    combinedDateTime.setMilliseconds(inputTime?.value.getMilliseconds());

    const todayDateTime = new Date();

    if (combinedDateTime.toDateString() === todayDateTime.toDateString() && combinedDateTime.getTime() <= todayDateTime.getTime()) {
        return { 'futureTimeRequired': { valid: true } }; 
    }

    return null;
};

export function futureDateValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) return null;

    const inputDate = new Date(control.value);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    inputDate.setHours(0, 0, 0, 0);

    if (inputDate.getTime() < today.getTime()) {
        return { 'futureDateRequired': { valid: true } }; 
    }

    return null;
  };
};

  export function pastDateValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) return null;

    const inputDate = new Date(control.value);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    inputDate.setHours(0, 0, 0, 0);

    if (inputDate.getTime() > today.getTime()) {
        return { 'pastDateRequired': { valid: true } }; 
    }

    return null;
  };
};
